module.exports = __webpack_public_path__ + "img/c07_unitthrowingaxeman_Normal_ua.716a5839.webp";